type TErrorsTranslations = {
	[key: string]: string;
};

type TErrorPageTranslations = {
	[language: string]: TErrorsTranslations;
};

const errorPageTranslations: TErrorPageTranslations = {
	ca: {
		'mybank:errorpage:ups': 'Uppsss…',
		'mybank:errorpage:errormsg:fatal':
			'Sembla que alguna cosa ha fallat en els nostres sistemes i la pàgina no està funcionant com hauria',
		'mybank:errorpage:errormsg2':
			'Si tens qualsevol dubte, contacta amb un dels nostres gestors al telèfon:',
		'mybank:errorpage:errortlf': '+376 881 960',
		'mybank:errorpage:back-hometext': 'Tornar a la home',
	},
	es: {
		'mybank:errorpage:ups': 'Uppsss…',
		'mybank:errorpage:errormsg:fatal':
			'Parece que algo ha fallado en nuestros sistemas y la página no está funcionando como debería',
		'mybank:errorpage:errormsg2':
			'Si tienes cualquier duda, contacta con uno de nuestros gestores en el teléfono:',
		'mybank:errorpage:errortlf': '+376 881 960',
		'mybank:errorpage:back-hometext': 'Volver a la home',
	},
	pt: {
		'mybank:errorpage:ups': 'Uppsss…',
		'mybank:errorpage:errormsg:fatal':
			'Parece que ocorreu uma falha no processo, e a página não está funcionando corretamente.',
		'mybank:errorpage:errormsg2':
			'Se o erro persistir ou se tiver alguma dúvida, entre em contato conosco pelo e-mail',
		'mybank:errorpage:errortlf': 'contato@myandbank.com.br',
		'mybank:errorpage:back-hometext': 'Volver a la home',
	},
	'ca-notFound': {
		'mybank:errorpage:ups': 'Uppsss…',
		'mybank:errorpage:errormsg:fatal':
			'Ho sento no hem trobat la pàgina sol·licitada',
		'mybank:errorpage:errormsg2':
			'Si tens qualsevol dubte, contacta amb un dels nostres gestors al telèfon:',
		'mybank:errorpage:errortlf': '+376 881 960',
		'mybank:errorpage:back-hometext': 'Tornar a la home',
	},
	'es-notFound': {
		'mybank:errorpage:ups': 'Uppsss…',
		'mybank:errorpage:errormsg:fatal':
			'Lo siento no encontramos la pagina solicitada',
		'mybank:errorpage:errormsg2':
			'Si tienes cualquier duda, contacta con uno de nuestros gestores en el teléfono:',
		'mybank:errorpage:errortlf': '+376 881 960',
		'mybank:errorpage:back-hometext': 'Volver a la home',
	},
	'pt-notFound': {
		'mybank:errorpage:ups': 'Uppsss…',
		'mybank:errorpage:errormsg:fatal':
			'Lo siento no encontramos la pagina solicitada',
		'mybank:errorpage:errormsg2':
			'Si tienes cualquier duda, contacta con uno de nuestros gestores en el teléfono:',
		'mybank:errorpage:errortlf': 'contato@myandbank.com.br',
		'mybank:errorpage:back-hometext': 'Volver a la home',
	},
};

export default errorPageTranslations;
